export default __webpack_public_path__ + "static/media/arai.af76ce2b.svg";